export enum EcoOrderListTabsEnum {
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  ALL = 'all',
}
